import { render } from "./SkeletonPageList.vue?vue&type=template&id=7f09bebf"
import script from "./SkeletonPageList.vue?vue&type=script&lang=js"
export * from "./SkeletonPageList.vue?vue&type=script&lang=js"

import "./SkeletonPageList.vue?vue&type=style&index=0&id=7f09bebf&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__